<template>
  <WorkPackageSubPageModule
    :workpackage="workpackage"
    :isMobile="isMobile"
    :location="location"
    :loading="loading"
    :background_color="workpackage_bg_hex"
    :foreground_color="workpackage_fg_hex"
    header_icon="info"
    header_text_short="INFO"
    header_text_long="INFORMATION"
    @headerBack="$router.push({name: `${location}WorkPackageInfo`, params: { nav_back: $route.params.nav_back} })"
  >
    <template #body>
      <DisableableInputField
        class="mt-2 mb-2"
        label="EXTERNAL.id"
        :value="workpackage.external_id"
        :is_disabled="!isEditMode"
        :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex"
        @change="requestSnackbarUpdate({
            url: [
              {projects: project_id},
              {trains: train_id},
              {taktareas: taktarea_id},
              {twaggons: twaggon_id},
              {tworkpackages: workpackage_id},
            ],
            update: {
              external_id: $event
            }
          }).then((payload) => {
            updateUObject(payload);
          })"
      />
      <TText
        value="Fill level"
        medium
        :color="workpackage_fg_hex"
        />
      <DisableableInputField
        class="mt-2 mb-2"
        label="FILL.level (hours)"
        :value="workpackage.time_effort_steps"
        :is_disabled="true"
        :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex"
      />
      <DisableableInputField
        class="mt-2 mb-2"
        label="CAPACITY.buffer (hours)"
        :value="workpackage.capacity_buffer_hours"
        :is_disabled="true"
        :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex"
      />
      <DisableableInputField
        class="mt-2 mb-2"
        label="FILL.level (%)"
        :value="workpackage.fill_percentage"
        :is_disabled="true"
        :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex"
      />
      <DisableableInputField
        class="mt-2 mb-2"
        label="CAPACITY.buffer (%)"
        :value="workpackage.capacity_buffer_percent"
        :is_disabled="true"
        :background_color="workpackage_bg_hex"
        :foreground_color="workpackage_fg_hex"
      />
      
      <template v-if="$store.state.Auth.current_user.email.includes('@takting.com')">
        <v-btn
        @click="createUObject({
            url: [
              {projects: project_id},
              {trains: train_id},
              {taktareas: taktarea_id},
              {twaggons: twaggon_id},
              {tworkpackages: workpackage_id},
              {dronejobs: ''},
              {showWithEntitiesNormalized: ''},
            ],
            u_object: { name: 'peter'},
          })"
          >
          start drone Job
        </v-btn>
        <div
          v-for="dronejob in getUObjects({ type: 'dronejobs', ids: workpackage.dronesjobs })"
          :key="`dronejobs${dronejob.id}`"
          :style="`color: ${workpackage.textcolor}`"
          >
          {{dronejob.id}} {{dronejob.status}}
        </div>
      </template>
    </template>
  </WorkPackageSubPageModule>
</template>
<script>
// import SubpageHeader from '@/modules/WorkPackageWIP/SubpageHeader.module.vue';

import { mapState, mapGetters, mapActions } from 'vuex';

import { WorkPackageReworkMixin } from '@/mixins/WorkPackageRework.mixin.js'
import WorkPackageSubPageModule from '@/modules/WorkPackageWIP/WorkPackageSubPageModule.module.vue';
import DisableableInputField from '@/components/WorkPackageWIP/DisableableInputField.component.vue';


  export default {
    components: {
      WorkPackageSubPageModule,
      DisableableInputField,
    },
    mixins: [
      WorkPackageReworkMixin
    ],
    props: ['location', ],

    data: () => ({
      bg: '#FFC900',
      fg: '#000',
      // bg: '#330011',
      // fg: '#FFF',
      show_total: true,
      is_edit: true,
      strategy_index: 4,
      show_drone_job: false,
    }),
    created() {
      this.loadData();
    },
    watch: {
      workpackage_id() {
        // this.loadData();
        this.show_drone_job = false;
      },
    },
    computed: {
      ...mapGetters('Ultra', [
        'getUObjects'
      ]),
      ...mapGetters('TWorkPackage', [
        'getCostStrategy',
        'getEquation'
      ]),
      ...mapGetters('Project', [
        'getOwnTWorkPackages',
        'hasProjectPermission'
      ]),
      ...mapState('TWorkPackage', [
        'cost_strategies'
      ]),
    },
    methods: {
      show(type) {
        return this.hasProjectPermission({project_id: this.project_id, ppermission: 'Read Work Package ' + type + ' Costs'}) ||
          (this.hasProjectPermission({project_id: this.project_id, ppermission: 'Read Own Work Package ' + type + ' Costs'}) &&
          this.getOwnTWorkPackages(this.project_id).includes(this.workpackage_id));
      },
      loadData() {
        this.requestUObject({
          url: [
            {projects: this.project_id},
            {trains: this.train_id},
            {taktareas: this.taktarea_id},
            {twaggons: this.twaggon_id},
            {tworkpackages: this.workpackage_id},
            {dronejobs: ''},
            {showWithEntitiesNormalized: ''},
          ],
        })
      },
      ...mapActions('Ultra', [
        'createUObject',
        'requestUObject',
        'updateUObject',
        'deleteUObject',
        'updateUObjectPosition',
      ]),
      ...mapActions('SnackBar', [
        'requestSnackbar',
        'requestSnackbarCreate',
        'requestSnackbarUpdate',
        'requestSnackbarUpdatePosition',
        'requestSnackbarDelete',
        'updateSnackbar'
      ]),
    },
  }
</script>
<style media="screen">
.work-package-costs-container {
  width: 100%;
}
.work-package-costs-total {
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
}
.work-package-costs-strategy {
  display: flex;
  flex-direction: column;
  grid-gap: 8px;
}
.work-package-costs-equation {
  display: flex;
  align-items: center;
}
</style>
